import { mixins } from "../app/mixin";

mixins.push({
  el: ".legal-document-page",

  data() {
    return {};
  },

  mounted() {
    // Find empty <p> tags that only contain non-breaking spaces
    const container = document.querySelector(".legal-wrapper .legal-content");
    if (!container) return;

    const paras = container.querySelectorAll("p");

    paras.forEach((p) => {
      // Skip if paragraph has child elements (strong, a, br, etc.)
      if (p.children.length > 0) {
        return;
      }

      // Normalize: replace NBSP with normal spaces, then trim
      const text = (p.textContent || "").replace(/\u00A0/g, " ").trim();

      // If still empty → mark as only-nbsp
      if (text === "") {
        p.classList.add("only-nbsp");
      }
    });
  },
});
